import { useLocation, Link, useNavigate } from 'react-router-dom'
import AdminError from '@components/admin/AdminError'
import { ArrowLeft, Home } from 'lucide-react'

const NotFound = () => {
  const { pathname } = useLocation()
  const navigate     = useNavigate()
  const isAdmin      = pathname.startsWith('/admin')

  if (isAdmin) return <AdminError code={404} />

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950 flex items-center justify-center px-4">
      <div className="text-center max-w-sm">
        <p className="text-8xl font-black text-gray-200 dark:text-gray-800 mb-2">404</p>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">Page not found</h1>
        <p className="text-gray-500 dark:text-gray-400 text-sm mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="flex items-center justify-center gap-3">
          <button onClick={() => navigate(-1)}
            className="flex items-center gap-2 px-4 py-2 rounded-xl border border-gray-300 dark:border-gray-700 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 text-sm font-medium transition-all">
            <ArrowLeft className="w-4 h-4" /> Go Back
          </button>
          <Link to="/"
            className="flex items-center gap-2 px-4 py-2 rounded-xl bg-primary-600 hover:bg-primary-700 text-white text-sm font-medium transition-all">
            <Home className="w-4 h-4" /> Go Home
          </Link>
        </div>
      </div>
    </div>
  )
}

export default NotFound
